import React, { Component } from 'react';
import Helmet from 'react-helmet';
import SEO from '../components/SEO/SEO';
import Header from '../components/Header/Header';
import ProjectListing from '../components/ProjectListing/ProjectListing';
import Transition from '../components/Transition/Transition';
import config from '../../data/SiteConfig';
import getWorks from '../shared/getWorks';

const PROJECT_LAYOUT = [4, 1, 2, 1, 4, 2, 2, 3, 1, 1, 1, 1, 1, 2, 1, 1, 1, 3, 1, 2, 1];

export default class Index extends Component {
  render() {
    const projectEdges = this.props.data.allMarkdownRemark.edges;
    const works = getWorks(projectEdges);
    return (
      <div className="page-container">
        <Helmet title={config.siteTitle} />
        <SEO postEdges={projectEdges} />
        <Transition>
          <Header data={this.props.data} />
          <div className="layout">
            <ProjectListing projectList={works} layout="fixed" column={PROJECT_LAYOUT} />
          </div>
        </Transition>
      </div>
    );
  }
}

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query IndexQuery {
    allTags: allMarkdownRemark {
      edges {
        node {
          frontmatter {
            tags
          }
        }
      }
    }
    allMarkdownRemark(
      limit: 21
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        fields: { audience: { eq: "row" }, slug: { ne: "/contact" } }
        frontmatter: { featured: { eq: "featured" } }
      }
    ) {
      edges {
        node {
          fields {
            slug
          }
          excerpt
          timeToRead
          frontmatter {
            title
            client
            tags
            color
            cover {
              childImageSharp {
                sizes(maxWidth: 1600, quality: 95) {
                  ...GatsbyImageSharpSizes_withWebp
                }
              }
            }
            date
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx